import BigNumber from 'bignumber.js'

// For naming key edge-v2-vv:xx; vv => version of web, xx => for what
export const LOCAL_STORAGE_TXS_KEY = 'edge-v2-0.1:txs'
export const LOCAL_STORAGE_AGREEMENT_KEY = 'edge-v2-0.1:agreement'

export const _1e6 = new BigNumber('1e6')
export const _E = new BigNumber('2.718281828459045')
export const LiqRatio = 100
export const SafeLiqRatio = 80
export const ForceMaxRatio = 90
export const SafeLTVRatio = (SafeLiqRatio / LiqRatio) * 100

export enum TaskNameId {
  usePool = 'usePool',
  oraclePrice = 'oraclePrice',
  balance = 'balance',
  tvl = 'tvl',
}

export enum RouteName {
  default = '/',
  pool = '/pool',
  termAndCondition = '/terms-and-conditions',
  faqs = '/faqs',
  whitelist = '/w',
}
